import React from 'react'

const Footer = () => {
  return (
    <footer className="footer hacking-font glass-panel">
      <span className="hacking-green">© {new Date().getFullYear()} Mahim Vyas | ShowLab</span>
    </footer>
  )
}

export default Footer
